"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var markup_1 = __importDefault(require("./markup"));

var getBoundaries_1 = __importDefault(require("./getBoundaries"));
/**
 * Highlight `words` in `text.
 */


exports.default = function (text, words) {
  if (words.length === 0) {
    return text;
  }

  var boundaries = getBoundaries_1.default(text, words);
  return markup_1.default(text, boundaries, '<mark>', '</mark>');
};